import {IEnumListEntry} from "../definitions";
export const STORAGE_CATEGORIES = {
    HIDDEN: "HIDDEN",
    PRODUCTION: "PRODUCTION",
    FARM: "FARM",
    SPECIAL: "SPECIAL"
};


export const STORAGE_CATEGORIES_LIST:IEnumListEntry[] = [
    { id: STORAGE_CATEGORIES.HIDDEN, label: STORAGE_CATEGORIES.HIDDEN },
    { id: STORAGE_CATEGORIES.PRODUCTION, label: STORAGE_CATEGORIES.PRODUCTION },
    { id: STORAGE_CATEGORIES.FARM, label: STORAGE_CATEGORIES.FARM },
    { id: STORAGE_CATEGORIES.SPECIAL, label: STORAGE_CATEGORIES.SPECIAL }
];


// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-storage-categories.ts